import React from 'react';
import { useBasicEventInfoQuery } from '@graphql/generated';
import PageNotFound from './PageNotFound';

export interface PageNotFoundWrapperProps {
  eventHandle: string;
}

export const PageNotFoundWrapper: React.FC<PageNotFoundWrapperProps> = props => {
  const { data, loading } = useBasicEventInfoQuery({ ssr: true, batchMode: 'fast', fetchPolicy: 'cache-first', variables: { eventHandle: props.eventHandle } });

  if (!loading && !data?.eventByName?.id) {
    return <PageNotFound />;
  }

  return <>{props.children}</>;
};
